export const styles = {
  container: {
    textAlign: "center",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },

  logoContainer: {
    display: "block",
    "& img": {
      pb: 1.5,
      m: "auto",
    },
  },

  bodyText: {
    color: "text.disabled",
    fontSize: "1.2rem",
    pt: 1.5,
    pb: 3,
  },

  link: {
    textDecoration: "none",
    color: "white.main",
    fontSize: "1rem",
  },

  button: {
    px: "86px",
    py: "12px",
  },
};
